import { useTranslation } from "@impero-com/common/utils/i18n";
import { Checkbox } from "antd";

import * as theme from "./ControlActivitiesArchivedFilterRow.css";
import { ControlActivitiesArchivedFilters } from "./useControlActivitiesArchivedFilter";

interface ControlActivitiesArchivedFilterRowProps {
    archivedFilters: ControlActivitiesArchivedFilters;
}

export function ControlActivitiesArchivedFilterRow({
    archivedFilters,
}: ControlActivitiesArchivedFilterRowProps) {
    const { active, archived, setActive, setArchived } = archivedFilters;
    const { t } = useTranslation();

    return (
        <div className={theme.row}>
            <Checkbox
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
            >
                {t("ControlActivitiesList_Active_FilterCheckbox")}
            </Checkbox>
            <Checkbox
                checked={archived}
                onChange={(e) => setArchived(e.target.checked)}
            >
                {t("ControlActivitiesList_Archived_FilterCheckbox")}
            </Checkbox>
        </div>
    );
}
